import styled from 'styled-components';
import { Modal } from 'lego-dist';

export const Text = styled.p`
color: #4A4A4A;
font-size: 16px;
font-weight: bold;
margin-top: 0px;
${({ theme }: any) => theme?.lego?.SucessModal?.Text}
`;

export const Wrapper = styled.div`
text-align: center;
height: 210px;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;


${({ theme }) => theme.breakPoints.tablet} {
    height: 310px;
}


${({ theme }: any) => theme?.lego?.SuccessModal?.Wrapper}
`;

export const ResponseImg = styled.img.attrs(() => ({
  className: 'errorModalImg',
}))`

width:120px;
height:120px;

${({ theme }) => theme.breakPoints.tablet} {
  width:184px;
  height:175px;
}

`;

export const ResponseModal = styled(Modal).attrs(() => ({
  className: 'errorModal',
}))`

margin-left: 20px;
margin-right: 20px;

${({ theme }) => theme.breakPoints.tablet} {
  margin-left: 0px;
  margin-right: 0px;
  margin: auto;
}

`;
